import React from 'react'
import { View, StyleSheet, ViewPropTypes } from 'react-native'
import Txt from '../Txt'
import Icon from '../Icons'
import PropTypes from 'prop-types'
import { useTheme } from '../../theming/ThemeProvider'
import { usePlatforms } from '../../hooks/usePlatforms'

const LocationsInformation = ({ origin, destination, isDriver, originText, destinationText, showStops, stopsCount, style }) => {
  const { theme } = useTheme()
  const { isTablet, isDesktop } = usePlatforms()
  const styles = useStyles(isTablet, isDesktop)
  return (
    <View style={[styles.locationInfoContainer, style]}>
      <View style={[styles.locationRow, { marginBottom: isDesktop ? 0 : 10 }]}>
        <View
          style={[
            styles.locationIcon,
            !isTablet && { backgroundColor: theme.GALLERY }
          ]}
        >
          <Icon
            name='Location'
            height={16}
            width={16}
            fill={theme.AZTEC}
          />
        </View>
        <View style={styles.locationText}>
          <Txt
            color={isTablet ? 'OUTER_SPACE' : 'SLATE_GRAY_TEXT'}
            text={origin}
            identity={isTablet ? 'body2Bold' : 'body1Bold'}
            style={styles.locationText}
          />
          <Txt
            color='SLATE_GRAY'
            text={isDriver ? 'Location' : originText}
            identity='body3'
          />
        </View>
      </View>
      {isDesktop && showStops && (
        <View style={styles.stops}>
          <Txt
            color='GOLDEN_GRASS'
            text={`${stopsCount || 0} stops`}
            identity='body'
          />
        </View>
      )}
      <View style={styles.locationRow}>
        <View
          style={[
            styles.locationIcon,
            !isTablet && { backgroundColor: theme.POLAR }
          ]}
        >
          <Icon
            name={isDriver ? 'User' : 'Flag'}
            height={16}
            width={16}
            fill={theme[isTablet ? 'AZTEC' : 'LOCHMARA']}
          />
        </View>
        <View style={styles.locationText}>
          <Txt
            color={isTablet ? 'OUTER_SPACE' : 'SLATE_GRAY_TEXT'}
            text={destination}
            identity={isTablet ? 'body2Bold' : 'body1Bold'}
            style={styles.locationText}
          />
          <Txt
            color='SLATE_GRAY'
            text={isDriver ? 'Name' : destinationText}
            identity='body3'
          />
        </View>
      </View>
    </View>
  )
}

const useStyles = (isTablet, isDesktop) => StyleSheet.create({
  locationInfoContainer: {
    flex: 1,
    justifyContent: 'space-between',
    alignItems: isDesktop ? 'center' : 'flex-start',
    flexDirection: isDesktop ? 'row' : 'column'
  },
  locationRow: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center'
  },
  locationIcon: {
    width: isDesktop ? 30 : 20,
    height: isDesktop ? 30 : 20,
    borderRadius: 100,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 10,
    overflow: 'hidden'
  },
  locationText: {
    width: isTablet ? 'auto' : 190
  },
  stops: {
    width: 80
  }
})

LocationsInformation.defaultProps = {
  originText: 'Origin',
  destinationText: 'Destination',
  isDriver: false,
  stopsCount: 0,
  showStops: false
}

LocationsInformation.propTypes = {
  origin: PropTypes.string,
  destination: PropTypes.string,
  isDriver: PropTypes.bool,
  originText: PropTypes.string,
  destinationText: PropTypes.string,
  stopsCount: PropTypes.number,
  showStops: PropTypes.bool,
  style: ViewPropTypes.style
}

export default LocationsInformation
